import { Col, LiveBadge, Row, Text } from 'components';
import { capitalize, checkIsLive, formatLocale } from 'lib';
import { memo } from 'react';
import { TableComponents } from 'screens/Admin/components';

const ListItem = memo(({ item, onClick = null, dataId }) => {
  const { type, date, users, score, _id, sport, text, winnerId } = item;
  const isSelected = dataId === _id;

  return (
    <TableComponents.Tr onClick={() => onClick(item._id)} isSelected={isSelected}>
      <TableComponents.Td isSelected={isSelected} first>
        <Text>
          {capitalize(type)}
          {score && ` - ${score}`}
        </Text>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Text>{capitalize(sport)}</Text>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        {type === 'game' ? (
          <Row noFlex ht="inherit">
            <Text wid="70px" right bold={winnerId === users[0]._id}>
              {users[0].name}
            </Text>

            <Text marg="0 10px">-</Text>

            <Text wid="70px" bold={winnerId === users[1]._id}>
              {users[1].name}
            </Text>
          </Row>
        ) : (
          <Text wid="140px" right>
            {users[0].name}
          </Text>
        )}
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Text wid="180px">{text}</Text>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Text>{date ? formatLocale(new Date(date), 'LLL do yyy, hh:mm a') : ''}</Text>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected} last>
        <Text>
          {checkIsLive(item) && (
            <Col noFlex wid="50px">
              <LiveBadge />
            </Col>
          )}
        </Text>
      </TableComponents.Td>
    </TableComponents.Tr>
  );
});

export default ListItem;
